import React from 'react';

// دلیل برگشت خوردن کار، به قرمز، زیر عنوان وظیفه.
//
// سرور این متن را فقط تا وقتی وظیفه در وضعیت «برگشت خورده» است پر می کند،
// پس اینجا شرطی برای وضعیت لازم نیست - وجود متن یعنی هنوز برگشت خورده است
// و کارشناس باید بداند چرا.
//
// هم داشبورد کارشناس و هم فهرست وظایف من از همین استفاده می کنند تا متن و
// رنگ در هر دو جا یکی باشد.
const RejectNote = ({ text }) => (
    text ?
        <div className='text-danger' style={{ fontSize: 12, marginTop: 2 }}>
            دلیل برگشت: {text}
        </div>
        :
        null
);

export default RejectNote;
